import React from "react";
import FormBackground from "../Components/FormBackground";
import { inject, observer } from "mobx-react";
import images from "Configs/images.config";
import { replaceStaticHost } from "Helpers/ImageManager";
import FormContainer from "./FormContainer";

@inject("ApplicationModel")
@observer
export default class FormWithBackground extends React.Component {
	render() {
		let text = this.props.ApplicationModel.text;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;
		let bgImages = {
			lg: replaceStaticHost(images.benefitLg),
			md: replaceStaticHost(images.benefitLg),
			sm: replaceStaticHost(images.benefitLg),
			xs: replaceStaticHost(images.benefitXs),
		};

		return (
			<FormBackground header={text.CONNECT_NOW} images={bgImages} windowSizes={windowSizes}>
				<FormContainer />
			</FormBackground>
		);
	}
}
